import clsx from "clsx";
import Avatar from "../../components/elements/Avatar"
import { Customer } from "../../components/models/customer/Customer"
import { TSize } from "../../resources/types";
import { getNameInitials, getPhoneNumberFromShortCodeFormat } from "../../utilities/miscFunctions"
import { ReactNode } from "react";
import { PencilIcon } from "@heroicons/react/20/solid";
import { Edit2Icon } from "lucide-react";
import { MdModeEditOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import useModal from "../../hooks/modalHook";
import CustomerKYCForm from "./add-customer/CustomerKYCForm";
import { customerDataToFormData } from "../../resources/converters";

interface IProps {
    customer: Customer,
    showId?: boolean;
    avatarSize?: TSize;
    metaData?: string | ReactNode;
    showMetaData?: boolean;
    showEdit?: boolean;
    onUpdated?: (customer: Customer) => void;
}

export default function CustomerComponent(props: IProps) {
    const { ModalComponent, updateModalStates, closeModal } = useModal();

    const editCustomer = () => {
        updateModalStates({
            show: true,
            children: <CustomerKYCForm
                formData={customerDataToFormData(props.customer)}
                onProceed={(customer: Customer) => {
                    props.onUpdated?.(customer);
                    closeModal();
                }}
            />,
            title: "Edit Customer",
            size: "2xl"
        })
    }

    return (
        <div className="flex items-center gap-4">
            <Avatar
                nameInitials={getNameInitials(props.customer.name)}
                size={props.avatarSize ?? "sm"}
                src={props.customer.picture_url}
            />

            <div>
                <div className="flex items-center">
                    <h1 className={clsx(
                        "text-xl md:text-2xl font-semibold text-gray-800 dark:text-text-dark-primary",
                        { ["text-xs md:text-sm"]: props.avatarSize === "xs" },
                        { ["text-md md:text-md"]: props.avatarSize === "sm" }
                    )}>
                        {props.customer.name}
                    </h1>
                    {props.showEdit && <FaRegEdit
                        className="ml-4 cursor-pointer"
                        title="Edit customer"
                        onClick={editCustomer}
                    />}

                </div>
                {props.showMetaData || props.metaData && (
                    props.metaData ??
                    <div>
                        {props.customer?.type} | {getPhoneNumberFromShortCodeFormat(props.customer?.phone)}
                    </div>
                )}
                {props.showId && <p className="text-sm text-gray-500 dark:text-text-dark-primary">Customer ID: CUST-{props.customer.id}</p>}
            </div>
            <ModalComponent />
        </div>
    )
}